// TODO: Move into MergeDialog file once it moves to TypeScript.
import { DocumentsForSave } from '@app/services';

export enum MergeDialogType {
  merge = 'merge',
  pull = 'pull',
  /** Do not display source changes, only compare two saved versions. */
  review = 'review',
  save = 'save'
};

export type MergeDialogOpenProps = (
  DocumentsForSave
  & {
    /** Commit message to start with @default ''. */
    defaultCommitMessage?: string,
    /** Version number that will be created by the merge @default current version + 1 patch. */
    newVersionNumber?: string | null,
    /** Function to call once the save is complete (whether it was cancelled or not) @default noop. */
    onComplete?: () => void,
    /** Type of merge that is happening @default MergeDialogType.save. */
    type: MergeDialogType;
  }
);
